module.exports = __webpack_public_path__ + "static/media/avatar-1577909_960_720.fc047347.png";